(function () {
    const sliderParts = document.querySelectorAll('.section-partners__slider .section-partners__list');
    document.addEventListener('DOMContentLoaded', () => {
        correctAnimationWidth();
        initAnim();
    })

    function initAnim() {
        if (sliderParts.length > 1) {
            sliderParts[0].classList.add('section-partners__slider--init-anim1');
            sliderParts[1].classList.add('section-partners__slider--init-anim2');
        }
    }


    function correctAnimationWidth() {
        const sliderFirstPart = document.querySelector('.section-partners__slider .section-partners__list');
        if (sliderFirstPart) {
            const width = document.querySelector('.section-partners__slider .section-partners__list').clientWidth;
            if (window.innerWidth > width) {
                document.documentElement.style.setProperty('--mover-w', window.innerWidth + "px");
            } else {
                document.documentElement.style.setProperty('--mover-w', width + "px");
            }
            sliderParts[0].classList.remove('section-partners__slider--init-anim1');
            sliderParts[1].classList.remove('section-partners__slider--init-anim2');

            initAnim();
        }
    }

    window.onresize = correctAnimationWidth;
})();